import { render, staticRenderFns } from "./MypagePhoneModal.vue?vue&type=template&id=27e1afcc&scoped=true&"
import script from "./MypagePhoneModal.vue?vue&type=script&lang=js&"
export * from "./MypagePhoneModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1afcc",
  null
  
)

export default component.exports